import React from "react";

export const downloadImageWithFetch = async (url, fileName = "file") => {

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isIOS) {
    // Can't reliably trigger download, open in new tab
    window.open(url, "_blank");
    return;
  }


  try {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  } catch (e) {
    downloadImage(url, fileName)
  }
}

export const downloadImage = (url, fileName = "file") => {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export const replaceIncorrectSymbols = (string) => {
  if (!string) {
    return ""
  }
  return string.replace(/â€\x9D/, "").replace(/\//, "").replace("”", "")
}

/**
 * @param value {number}
 * @param percent {number}
 * @returns {number}
 */
export const getPercentage = (value, percent) => {
  return (value / 100) * percent;
}

/**
 * @param value {number}
 * @param fromTotal {number}
 * @returns {number} %
 */
export const getPercentAmount = (value, fromTotal) => {
  if (!value) {
    return 0
  }
  return (fromTotal / value) * 100;
}

/**
 * common func for checking if need to show
 * @param fabricatorSettings {object}
 * @param forCartItems {array}
 * @return {array} // {currency: "USD", cartItems: []}
 */
export const getDifferentCurrencyCartItems = (fabricatorSettings, forCartItems = []) => {
  let totalArray = [];
  if (!fabricatorSettings.useDifferentCurrencies || !forCartItems.length) {
    return totalArray
  }
  forCartItems.forEach(cartItem => {
    if (cartItem.cartFeature && cartItem.cartFeature.getFeatureCurrency) {
      const featureCurrency = cartItem.cartFeature.getFeatureCurrency();
      if (featureCurrency && (featureCurrency !== fabricatorSettings.currency)) {
        const existingGroup = totalArray.find(filterGroupObject => {
          return filterGroupObject.currency === featureCurrency
        });
        if (existingGroup) {
          existingGroup.cartItems.push(cartItem);
        } else {
          totalArray.push({
            currency: featureCurrency,
            cartItems: [cartItem]
          })
        }
      }
    }
  });
  // console.log("totalArray", totalArray);
  return totalArray
}

/**
 * Returns next max integer current from array of objects, for example
 * [] => 1
 * [{id: 1, someProp: ""}, {id: 3, someProp: ""}, {id: 6, someProp: ""}] => 7
 * @param array {array}
 * @param property {string}
 * @param startingFrom {number}
 * @returns {number}
 */
export const getNextMaxNumberFromList = (array, property, startingFrom = 1) => {
  return array.length ? Math.max(...array.map(arrayItem => +arrayItem[property])) + 1 : startingFrom;
}

/**
 * highlights search text in the name
 * @param finalName {string}
 * @param searchText {string}
 * @return {string}
 */
export const highlightStringOnSearch = (finalName, searchText) => {
  if (!searchText) {
    return finalName
  }
  const escapedSearch = searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(escapedSearch, "gi"); // Case-insensitive search
  return <span dangerouslySetInnerHTML={{
    __html: finalName.replace(regex, (match) => {
      return `<span class="color-secondary_active">${match}</span>`
    })
  }}/>
}

export function onBeforeUnload(e) {
  e.preventDefault(); // Some browsers require this
  e.returnValue = ''; // Setting to empty string is the standard way
  return ''; // Still needed for some compatibility
}

export const lowerCaseFirstLetterKeys = (obj) => {
  // Ensure the input is an object and not null or an array
  if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
    return obj;
  }

  return Object.entries(obj).reduce((newObj, [key, value]) => {
    // Lowercase the first character and concatenate with the rest of the string
    const newKey = key.charAt(0).toLowerCase() + key.slice(1);
    newObj[newKey] = value;
    return newObj;
  }, {});
}
